import React, { useState, useEffect } from "react";
import "./ReviewStudentListHW.css";
import Table from "react-bootstrap/Table";
import StudentTablePropsHW from "./Table_Props/StudentTablePropsHW";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import PendingSPopupHw from "./PendingSPopupHw";
import PendingStudentPopupHW from "./Table_Props/PendingStudentPopupHW";
import SuccessfullReviewHW from "./SuccessfullOnreview/SuccessfullReviewHW";
import moment from "moment";
import { IP } from "../../../../internalServer";

const ReviewStudentListHW = () => {
  const { state } = useLocation();

  const [basicinfo, setBasicInfo] = useState({});
  const [studentinfo, setStudentInfo] = useState([]);
  const [noresponse, setNoResponse] = useState(false);
  const [display, setDisplay] = useState(false);
  const [pendingPopup, setPendingPopup1] = useState(false);
  const [disable, setDisable] = useState(true);
  const [pendingpopup, setPendingPopup] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [seccPopup, setSeccPopup] = useState(false);
  const [review, setReview] = useState(false);
  const [pendingThenReview, setPendingThenReview] = useState(false);
  const [loading, setLoading] = useState(false);

  const formatDate = (inputDate) => {
    const d = new Date(inputDate);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1,
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const header = (para) => `${para[1]} ${para[0]} HW`;

  const timeDate = (val) => {
    const out = moment(val).format("DD/MM/YYYY");
    return out === "NaN/NaN/NaN" ? "Not Submitted Yet" : out;
  };

  // 🟦 debounce search
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchvalue.trim());
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchvalue]);

  // 🟦 fetch students API
  useEffect(() => {
    const fetchStudents = async () => {
      setLoading(true);
      setNoResponse(false);

      try {
        const response = await axios.get(
          `/api/v1/homework/studentHomework/getByHomeworkId/${state.homework_id}?name=${debouncedSearch}`,
        );

        const data = response.data.data;

        if (!data || data.length === 0) {
          setStudentInfo([]);
          setNoResponse(true);
          return;
        }

        setNoResponse(false);

        // basic info only once
        const first = data[0];
        setBasicInfo({
          header: header(first.homework_id.tags),
          belowHeader: first.homework_id.subject_id.name,
          timeDate: formatDate(first.deadline),
          chapter: first.homework_id.tags[0],
          homework_name: first.homework_id.name,
        });

        const formatted = data.map((obj) => ({
          HomeWork_id: obj.homework_id.id,
          Student_id: obj.student_id.id,
          avatar_profile: obj.student_id.avatar_profile,
          gender: obj.student_id.gender,
          subscription: obj.student_id.isSubscribed,
          profile_pic: obj.student_id.profile_picture
            ? IP +
              obj.student_id.profile_picture.substring(
                obj.student_id.profile_picture.indexOf("/"),
              )
            : "/images/table pic1.svg",
          Name: obj.student_id.name,
          School_Email: obj.student_id.roll_number,
          Class: `${obj.homework_id.standard_id.name} Class`,
          Division: obj.homework_id.section_id.name,
          Submited_Date: timeDate(obj.submitted_on),
          submittedDate: obj.submitted_on,
          deadlineDate: obj.deadline,
          Deadline: timeDate(obj.deadline),
          Status: obj.status,
          obtained_marks: obj.status === "completed" ? obj.obtained_marks : "-",
          total_marks: obj.homework_id.total_marks,
        }));

        setStudentInfo(formatted);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [debouncedSearch]);

  // 🟦 popup logic
  useEffect(() => {
    studentinfo.forEach((obj) => {
      if (obj.Status === "review") {
        setDisable(true);
        setPendingPopup1(true);
      } else if (obj.Status === "pending") {
        setPendingPopup1(true);
      } else {
        setDisable(false);
      }
    });
  }, [studentinfo]);

  const callApiToComplete = async () => {
    try {
      const res = await axios.put(
        `/api/v1/homework/updateStatus/${state.homework_id}`,
        { status: "completed" },
      );
      if (res) setSeccPopup(true);
    } catch (err) {
      console.error(err);
    }
  };

  const helper1 = () => {
    const hasPending = studentinfo.some((s) => s.Status === "pending");
    const hasReview = studentinfo.some((s) => s.Status === "review");

    if (hasPending && hasReview) {
      setPendingThenReview(true);
      setDisplay(true);
      return;
    }

    if (hasPending) {
      setDisplay(true);
      return;
    }

    if (hasReview) {
      setReview(true);
      return;
    }

    callApiToComplete();
  };

  const handlePendingContinue = () => {
    setDisplay(false);
    if (pendingThenReview) {
      setPendingThenReview(false);
      setReview(true);
    } else {
      callApiToComplete();
    }
  };

  const isAnyStudentOnReview = studentinfo.some(
    (student) => student.Status === "review",
  );
  const handleReviewContinue = () => {
    setReview(false);
    callApiToComplete();
  };
  const navigate = useNavigate();
  return (
    <>
      {/* HEADER */}
      <div
        onClick={() => navigate("/PublishedHomework")}
        className="d-flex flex-row align-items-center "
      >
        <img
          style={{ cursor: "pointer" }}
          src="/images/Back Arrow.svg"
          alt=""
        />
        <div className="d-flex flex-column gap-1">
          <span className="head_manual">Homework Review</span>
          <span className="fw-small text-muted" style={{ fontSize: "10px" }}>
            Dashboard / Homework / On Review / {basicinfo.homework_name}
          </span>
        </div>
      </div>

      <div className="me-5 d-flex align-items-center justify-content-between">
        <div className="mt-2 ms-2 published_tittle_heading">
          {basicinfo.homework_name}
        </div>
      </div>

      {/* MAIN WHITE BOX */}
      <div
        className="h-100 p-2 d-flex flex-column rounded-2"
        style={{ backgroundColor: "white", width: "100%" }}
      >
        <div className="me-5 mt-3 d-flex align-items-center justify-content-between">
          <div className="mt-1 ms-1 d-flex align-items-center ">
            <span className="open_ststus_hw" style={{ marginRight: "20px" }}>
              On review
            </span>
            <span className="published_hw_header_subject_name me-2">
              {basicinfo.belowHeader} |
            </span>
            <span className="published_hw_header_subject_name">Deadline :</span>
            <span className="ms-3 scheduled_date_time">
              {basicinfo.timeDate}
            </span>
          </div>

          {/* SEARCH BAR */}
          <div className="col-12 col-md-4 p-0">
            <input
              className="form-control mr-sm-2 m-0 name_search_box"
              type="search"
              placeholder="Search by Student name"
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <img
              className="name_search_icon"
              src="/images/search icon.svg"
              alt=""
            />
          </div>
        </div>

        {/* TABLE */}
        <div>
          <div
            className="mt-4 table_area col-12 ml-0 orange-scrollBar"
            style={{
              maxHeight: "380px",
              overflowY: "scroll",
              paddingBottom: "10px",
            }}
          >
            <Table
              responsive
              borderless
              className="student_profile_table"
              style={{ textAlign: "center" }}
            >
              <thead style={{ position: "sticky", top: "0px" }}>
                <tr>
                  {" "}
                  {/* <th style={{ backgroundColor: "#e2e2e2", color: "white" }}> Subscription </th> */}{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Name{" "}
                  </th>{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Roll No{" "}
                  </th>{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Class{" "}
                  </th>{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Division{" "}
                  </th>{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Date submitted{" "}
                  </th>{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Marks{" "}
                  </th>{" "}
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {" "}
                    Status{" "}
                  </th>{" "}
                  {/* <th style={{ backgroundColor: "#e2e2e2", color: "white" }}> Action </th> */}{" "}
                </tr>
              </thead>

              <tbody>
                {/* LOADING UI */}
                {loading && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      <img
                        src="/gif/LoaderDot.gif"
                        alt="loading"
                        style={{ height: "40px" }}
                      />
                      <div className="mt-2 text-muted">Loading students...</div>
                    </td>
                  </tr>
                )}

                {/* NO STUDENT FOUND */}
                {!loading && noresponse && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      <div className="mt-2 fw-bold">No student found</div>
                      <div className="text-muted" style={{ fontSize: "12px" }}>
                        Try searching with a different name.
                      </div>
                    </td>
                  </tr>
                )}

                {/* TABLE ROWS */}
                {!loading && !noresponse && (
                  <StudentTablePropsHW
                    studentinfo={studentinfo}
                    basicinfo={basicinfo}
                    setPendingPopup={setPendingPopup}
                  />
                )}
              </tbody>
            </Table>
          </div>

          {/* BUTTON */}
          <div className="buttons_right ml-10">
            <button
              className="Edit_Btn px-4"
              onClick={helper1}
              disabled={isAnyStudentOnReview}
              title={
                isAnyStudentOnReview
                  ? "Cannot publish while students are under review"
                  : ""
              }
              style={{
                opacity: isAnyStudentOnReview ? 0.5 : 1,
                cursor: isAnyStudentOnReview ? "not-allowed" : "pointer",
              }}
            >
              Publish Result
            </button>
          </div>
        </div>
      </div>

      {/* POPUPS */}
      {pendingpopup && <PendingSPopupHw setPendingPopup1={setPendingPopup} />}
      {display && (
        <PendingStudentPopupHW
          open={display}
          type="pending"
          onClose={() => setDisplay(false)}
          onContinue={handlePendingContinue}
        />
      )}
      {review && (
        <PendingStudentPopupHW
          open={review}
          type="review"
          onClose={() => setReview(false)}
          onContinue={handleReviewContinue}
        />
      )}
      {seccPopup && <SuccessfullReviewHW />}
    </>
  );
};

export default ReviewStudentListHW;
